import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation
} from '@angular/core';
import { ButtonModule } from '@com-delta-idp/mnx-ui-kit';
import { BusinessProfileSelectorComponent } from '../../features/business/business-profile-selector.component';
import { CompanySelection } from '../../features/business/models/business-profile-selector.models';
import { ProfileSelectorHeaderComponent } from '../../features/header/profile-selector-header.component';
import { PersonalProfileSelectorComponent } from '../../features/personal/personal-profile-selector.component';
import { ProfileSelectorDetails } from './models/profile-selector.interface';

@Component({
  selector: 'idp-profile-selector-ui',
  standalone: true,
  templateUrl: './profile-selector.component.html',
  styleUrls: ['./profile-selector.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [
    CommonModule,
    BusinessProfileSelectorComponent,
    PersonalProfileSelectorComponent,
    ProfileSelectorHeaderComponent,
    ButtonModule
  ]
})
export class ProfileSelectorComponent implements AfterViewInit {
  @Input() profileDetails = {} as ProfileSelectorDetails;
  @Input() displayTermsOfUse = false;
  @Input() personalStateSelected = false;
  @Input() fromStandAlonePage = false;
  @Input() businessStateSelected = {} as {
    selectedState: boolean;
    accountIndex: number;
  };

  @Input() enableMachCoreProfileSelector = false;

  @Output() emitBusinessProfile = new EventEmitter<CompanySelection>();
  @Output() emitPersonalProfile = new EventEmitter<CompanySelection>();
  @Output() closeFlyout = new EventEmitter<boolean>();
  @Output() logout: EventEmitter<Event | undefined> = new EventEmitter();
  @Output() profileAnalytics = new EventEmitter<Event>();

  ngAfterViewInit(): void {
    this.addLinkClass();
  }

  addLinkClass(): void {
    const elements = document.querySelectorAll(
      '.profile-selector-machcore__footerSubText a'
    );
    elements.forEach((element) => {
      element.classList.add('link');
    });
  }

  emitLogout(event?: Event | boolean): void {
    const eventToEmit = event instanceof Event ? event : undefined;
    this.logout.emit(eventToEmit);
  }

  onClose(): void {
    this.closeFlyout.emit(false);
  }

  businessProfileSelected(params: CompanySelection): void {
    this.emitBusinessProfile.emit(params);
  }

  personalProfileSelected(params: CompanySelection): void {
    this.emitPersonalProfile.emit(params);
  }

  handleProfileAnalytics(event: Event): void {
    this.profileAnalytics.emit(event);
  }
}
